import axios, { AxiosRequestConfig } from 'axios';
import { getStorageValue } from 'src/hooks/useLocalStorage';

const accessToken = getStorageValue('accessToken', null);

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config: AxiosRequestConfig<any>) => {
    if (accessToken) {
      if (config.headers) {
        // eslint-disable-next-line no-param-reassign
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
    }
    return config;
  },
  error => Promise.reject(error)
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  response => {
    if (response.data) {
      if (response.data.accessToken) {
        axiosInstance.defaults.headers.common.Authorization = `Bearer ${response.data.accessToken}`;
      }
    }
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  error => {
    if (error.request.responseURL.includes('signin')) {
      return Promise.reject(error);
    }

    if (error.response.status === 401) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('roles');
      window.location.replace('/');
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

export default axiosInstance;
